import { useId } from 'react';
import { HAND_PATH, HAND_VIEWBOX } from './greetMarkPaths';

type Props = {
  /** Width in px; height follows the hand's 96:92 shape. */
  size?: number;
  className?: string;
};

/**
 * The GreetAI hand fills with green from the wrist up, gives a small wave when full,
 * then fades and starts again (2.4 s loop). Pure CSS so it runs before hydration.
 * It stays invisible for the first 250 ms, so quick loads never flash it.
 * With reduced motion it is a still green hand.
 */
export function GreetLoader({ size = 56, className }: Props) {
  const clipId = `greet-loader-${useId().replace(/:/g, '')}`;
  return (
    <svg
      viewBox={HAND_VIEWBOX}
      width={size}
      height={Math.round((size * 92) / 96)}
      className={`greet-loader ${className ?? ''}`}
      // The wave rotates the hand past the viewBox; without this its thumb and palm get cut off.
      style={{ overflow: 'visible' }}
      role="status"
      aria-label="Loading">
      <defs>
        <clipPath id={clipId}>
          <path fillRule="evenodd" clipRule="evenodd" d={HAND_PATH} />
        </clipPath>
      </defs>
      <g className="greet-loader-hand">
        <path
          className="greet-loader-track"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="currentColor"
          d={HAND_PATH}
        />
        <g clipPath={`url(#${clipId})`}>
          <rect className="greet-loader-fill" x="0" y="0" width="96" height="92" />
        </g>
      </g>
    </svg>
  );
}
